import { FormDrawerContent, FormFetchDrawer, UpdateDrawerFormProps } from "@dgs/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { CompanyDrawerFormFields } from "../companies/CompanyDrawerFormFields";
import { useCompanyFormValidation } from "../companies/create/Form";
import { companyService } from "../shared/api/companyService";
import { ICompanyUpdateResource } from "../shared/types";

export const CompanyUpdateDrawer: FC<UpdateDrawerFormProps<ICompanyUpdateResource>> = (props) => {
	const { t } = useTranslation();
	const validate = useCompanyFormValidation();

	return (
		<FormFetchDrawer
			{...props}
			title={t("Edit company")}
			queryFn={() => companyService.show(props.id).then((x) => x.data.data)}
			queryKey={companyService.showKey(props.id)}
			validate={validate}
			renderSuccess={(formProps) => (
				<FormDrawerContent {...props} {...formProps}>
					<CompanyDrawerFormFields />
				</FormDrawerContent>
			)}
		/>
	);
};
